import React from 'react';
import { Container } from 'react-bootstrap';
import Header from './Header';
import Footer from './footer';

const AboutUsPage = () => {
  return (
    <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      
      <div style={{ flexGrow: 1, paddingTop: '120px', paddingBottom: '60px' }}>
        <Container 
            style={{ 
                backgroundColor: 'white', 
                padding: '40px', 
                borderRadius: '12px', 
                boxShadow: '0 4px 15px rgba(0,0,0,0.05)', 
                maxWidth: '900px', 
                margin: '0 auto' 
            }}
        >
          <h2 style={{ textAlign: 'center', marginBottom: '40px', color: '#009fe3', fontWeight: 'bold', fontSize: '2.5rem' }}>
            Sobre o Engenheiros4IU
          </h2>

          <h3 style={{ color: '#0056b3', marginTop: '40px', marginBottom: '20px', borderBottom: '2px solid #0056b3', paddingBottom: '10px' }}>
            A nossa história
          </h3>
          <p>O <strong>Engenheiros4IU</strong> nasce da constatação de uma desigualdade persistente:</p>
          <ul>
            <li>por um lado, <strong>associações e organizações sociais</strong> enfrentam desafios técnicos concretos, como a falta de recursos digitais, limitações de engenharia, dificuldades de planeamento e inovação;</li>
            <li>por outro, <strong>engenheiros e estudantes</strong> detêm conhecimento técnico que raramente encontra canais estruturados para gerar impacto social direto.</li>
          </ul>
          <p>
            Esta desconexão traduz-se em oportunidades perdidas: projetos que nunca avançam, problemas que se acumulam e competências que ficam subaproveitadas.
            <br/><br/>
            O Engenheiros4IU surge para <strong>ligar estes dois mundos.</strong>
          </p>

          <h3 style={{ color: '#009fe3', marginTop: '50px', marginBottom: '20px', borderBottom: '2px solid #009fe3', paddingBottom: '10px' }}>
            O que fazemos?
          </h3>
          <p>Criámos uma <strong>plataforma digital</strong> que permite a organizações sem fins lucrativos:</p>
          <ul>
            <li>transformar necessidades reais em <strong>desafios técnicos concretos</strong>;</li>
            <li>encontrar engenheiros e estudantes dispostos a colaborar de forma voluntária;</li>
            <li>desenvolver soluções ajustadas à sua realidade, com impacto mensurável.</li>
          </ul>
          <p>Ao mesmo tempo, o Engenheiros4IU oferece a engenheiros e estudantes:</p>
          <ul>
            <li>a possibilidade de aplicar o seu conhecimento a problemas reais;</li>
            <li>experiência prática com significado social;</li>
            <li>reconhecimento visível do seu contributo e impacto.</li>
          </ul>

          <h3 style={{ color: '#0056b3', marginTop: '50px', marginBottom: '20px', borderBottom: '2px solid #0056b3', paddingBottom: '10px' }}>
            A nossa missão
          </h3>
          <p>Democratizar o acesso a competências técnicas para o setor social, promovendo uma engenharia mais justa, útil e socialmente comprometida.</p>
          <p>Acreditamos que:</p>
          <ul>
            <li>o conhecimento técnico é um bem social;</li>
            <li>a inovação não deve estar reservada a quem pode pagar por ela;</li>
            <li>a colaboração voluntária, quando bem estruturada, gera valor real e duradouro.</li>
          </ul>

          <h3 style={{ color: '#009fe3', marginTop: '50px', marginBottom: '20px', borderBottom: '2px solid #009fe3', paddingBottom: '10px' }}>
            Como trabalhamos?
          </h3>
          <p>O Engenheiros4IU:</p>
          <ul>
            <li>não é um programa fechado, nem funciona por edições;</li>
            <li>não substitui serviços profissionais contratados;</li>
            <li>não cria relações laborais.</li>
          </ul>
          <p>É uma <strong>infraestrutura de mediação</strong> que:</p>
          <ul>
            <li>facilita o encontro entre necessidades e competências;</li>
            <li>promove projetos proporcionais, realistas e colaborativos;</li>
            <li>valoriza a transparência, o compromisso e o impacto.</li>
          </ul>
          <p>Os projetos desenvolvem-se de forma flexível, respeitando o tempo e a disponibilidade das pessoas envolvidas.</p>

          <h3 style={{ color: '#0056b3', marginTop: '50px', marginBottom: '20px', borderBottom: '2px solid #0056b3', paddingBottom: '10px' }}>
            O impacto que queremos gerar
          </h3>
          <p>Trabalhamos para:</p>
          <ul>
            <li>reforçar a capacidade técnica das organizações sociais;</li>
            <li>reduzir desigualdades no acesso à tecnologia e à engenharia;</li>
            <li>criar oportunidades de aprendizagem prática para estudantes;</li>
            <li>promover uma cultura de responsabilidade social na engenharia.</li>
          </ul>
          <p>O impacto do Engenheiros4IU é <strong>mensurável, visível e partilhado</strong>, através de projetos concluídos, horas técnicas voluntárias, soluções entregues e pessoas envolvidas.</p>

          <h3 style={{ color: '#009fe3', marginTop: '50px', marginBottom: '20px', borderBottom: '2px solid #009fe3', paddingBottom: '10px' }}>
            Transparência e responsabilidade
          </h3>
          <p>Acreditamos que confiança se constrói com clareza. Por isso:</p>
          <ul>
            <li>os projetos são documentados;</li>
            <li>os resultados são partilhados com consentimento;</li>
            <li>os limites do trabalho voluntário são assumidos desde o início.</li>
          </ul>
          <p>O Engenheiros4IU cria condições para a colaboração, o sucesso depende do envolvimento de todas as partes.</p>

          <div style={{ backgroundColor: '#f0f8ff', padding: '30px', borderRadius: '8px', borderLeft: '6px solid #009fe3', marginTop: '50px' }}>
            <h3 style={{ color: '#0056b3', marginTop: '0', marginBottom: '15px' }}>Junta-te a nós</h3>
            <p style={{ color: '#333' }}>Se és:</p>
            <ul style={{ marginBottom: '0', color: '#333' }}>
              <li>uma <strong>associação</strong> com um desafio técnico,</li>
              <li>um/a <strong>engenheiro/a</strong> ou <strong>estudante</strong> que quer contribuir com o seu conhecimento.</li>
            </ul>
          </div>

        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUsPage;
